import React from 'react';
import './styles/common.css'
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Resource/ResourceTracker/Resource';
import WorkersList from './pages/Resource/ResourceTracker/Workers/Workers';
import Login from './pages/Login/Login';
import { Graph } from './pages/Resource/ResourceTracker/Graph/Graph';
import Maps from './pages/Resource/ResourceTracker/Maps/Maps';
import OnCall from './pages/Resource/ResourceTracker/OnCall/OnCall';
import { useAuth } from './auth/auth';
import { ToastContainer } from 'react-toastify';
import Layout from './Layout/Layout';
import Clients from './pages/Collaboriations/Clients/Clients';
import Projects from './pages/Collaboriations/Projects/Project';
import RTdata from './pages/RT-Data/RTdata';
import PaymentMethod from './pages/Payroll/Payment Methods/PaymentMethod';
import WorkforceMap from './pages/Resource/MapOverview/WorkforceMap';
import Competencies from './pages/Competencies/Competencies';
import Experiences from './pages/Experiences/Experiences';
import RegionsMap from './pages/Resource/MapOverview/RegionsMap/RegionsMap';
import LiveTracker from './pages/Resource/LiveTracker/Livetracker';
import StaffDetails from './pages/Resource/Staff-Details/StaffDetails';
import LocationLogger from './pages/Resource/ResourceTracker/LocationLogger/LocationLogger';
import GenerateTimesheet from './pages/Resource/Generate Timesheet/GenerateTimesheet';
import Signin from './pages/Signin/Signin';
import Drivers from './pages/Drivers/Drivers';
import ProfileTab from './pages/Profile Page/ProfileTab';
import Tickets from './pages/Tickets/Tickets';
import CreateWorker from './pages/Resource/Staff-Details/CreateWorker';
import EditWorker from './pages/Resource/Staff-Details/EditWorker';
import RestoreShifts from './pages/Resource/RestoreShifts/RestoreShifts';
import VersionHistory from './pages/Resource/ResourceTracker/VersionHistory/VersionHistory';
import TicketDocuments from './pages/Profile Page/Profile/Tickets/TicketDocuments/TicketDocuments';
import MyProfileTab from './pages/My Profile/ProfileTabs';
import JobListings from './pages/Job Listings/JobListings';
import Interests from './pages/Job Listings/Interests/Interests';
import Dashboard from './pages/Admin/Dashboard/Dashboard';
import ProfileAdmin from './pages/Admin/Dashboard/User Managment/Profile/Profile';
import EditUserAccount from './pages/Admin/Dashboard/User Managment/Manage Users/Edit User Account/EditUserAccount';
import WebForms from './pages/Mobile/WebForms/WebFroms';
import LocationMatrices from './pages/Distance/LocationMatrices';
import WorkersAvailability from './pages/Mobile/WorkersAvailability/WorkersAvailability';
import FatigueCheck from './pages/Fatigue/FatigueCheck';
import FatigueUser from './pages/Fatigue/FatigueUser';
import FatigueCalculation from './pages/Fatigue/FatigueCalculations';
import MacrailUploadPage from './pages/Fatigue/MacrailUploadPage/MacrailUploadPage';
import ChangePassword from './pages/Login/ChangePassword/ChangePassword';
import GenerateFatigues from './pages/Resource/GenerateFatigues/GenerateFatigues';
import GenerateWeeklyHours from './pages/Resource/GenerateWeeklyHours/GenerateWeeklyHours';
import WeeklyNewUsersTable from './pages/Resource/ResourceTracker/WeeklyNewUsersTable/WeeklyNewUsersTable';
import IdentificationType from './pages/RT-Data/IdentificationType/IdentificationType';
import CalendarDownloads from './pages/CalendarDownloads/CalendarDownloads';
import CancelledShifts from './pages/Resource/ResourceTracker/CancelledShifts/CancelledShifts';
import WorkRoleSuggestions from './pages/RT-Data/WorkRole/WorkRole';
import PaceSiteContact from './pages/RT-Data/PaceSiteContact/PaceSiteContact';
import ClientSiteContact from './pages/RT-Data/ClientSiteContact/ClientSiteContacts';
import OnboardingForms from './pages/Onboarding Forms/OnboardingForms';
import OnboardingFormDocuments from './pages/Profile Page/Profile/OnboardingForms/OnboardingFormDocuments/OnboardingFormDocuments';
import UpdateDataPage from './pages/UpdateDataPage/UpdateDataPage';
import PendingUpdates from './pages/UpdateDataPage/PendingUpdates/PendingUpdates';
import RequestDelete from './pages/UpdateDataPage/RequestDelete/RequestDelete';

const App = () => {
  const { state } = useAuth();

  return (
    <>
      {state.user?.token && (
        <Layout>
          <Routes>
            <Route path="/pace-team/resourcing/resource-tracker/workers" element={<WorkersList />} />
            <Route path="/pace-team/resourcing/resource-tracker/graph" element={<Graph />} />
            <Route path="/pace-team/resourcing/resource-tracker/maps" element={<Maps />} />
            <Route path="/pace-team/resourcing/resource-tracker/on-call" element={<OnCall />} />
            <Route path="/pace-team/resourcing/version-history" element={<VersionHistory />} />
            <Route path="/pace-team/resourcing/resource-tracker/generate-timesheet" element={<GenerateTimesheet />} />
            <Route path="/pace-team/resourcing/staff-details" element={<StaffDetails />} />
            <Route path="/pace-team/resourcing/create-worker" element={<CreateWorker />} />
            <Route path="/pace-team/resourcing/edit-worker" element={<EditWorker />} />
            <Route path="/pace-team/resourcing/restore-shifts" element={<RestoreShifts />} />
            <Route path="/pace-team/resourcing/workforce-map" element={<WorkforceMap />} />
            <Route path="/pace-team/resourcing/regions-map" element={<RegionsMap />} />
            <Route path="/pace-team/resourcing/live-tracker" element={<LiveTracker />} />
            <Route path="/pace-team/collaborations/clients" element={<Clients />} />
            <Route path="/pace-team/collaborations/projects" element={<Projects />} />
            <Route path="/pace-team/rt-data/pace-site-contact" element={<PaceSiteContact />} />
            <Route path="/pace-team/rt-data/client-site-contact" element={<ClientSiteContact />} />
            <Route path="/pace-team/rt-data/work-role-suggestions" element={<WorkRoleSuggestions />} />
            <Route path="/pace-team/payroll/payment-method" element={<PaymentMethod />} />
            <Route path="/pace-team/competencies" element={<Competencies />} />
            <Route path="/pace-team/experiences" element={<Experiences />} />
            <Route path="/pace-team/tickets" element={<Tickets />} />
            <Route path="/pace-team/onboarding-forms" element={<OnboardingForms />} />
            <Route path="/pace-team/resourcing/get-worker-onboarding-form-documents" element={<OnboardingFormDocuments />} />
            <Route path="/pace-team/resource-tracker/location-logger" element={<LocationLogger />} />
            <Route path="/pace-team/resource-tracker/signin" element={<Signin />} />
            <Route path="/pace-team/resourcing/profile" element={<ProfileTab />} />
            <Route path="/pace-team/resourcing/my-profile" element={<MyProfileTab />} />
            <Route path="/pace-team/resourcing/authorized-drivers" element={<Drivers />} />
            <Route path="/pace-team/resourcing/dashboard" element={<Dashboard />} />
            <Route path="/pace-team/resourcing/dashboard/edit-user" element={<EditUserAccount />} />
            <Route path="/pace-team/resourcing/dashboard/profile-data" element={<ProfileAdmin />} />
            <Route path="/pace-team/resourcing/get-worker-tickes-documents" element={<TicketDocuments />} />
            <Route path="/pace-team/resourcing/job-listings" element={<JobListings />} />
            <Route path="/pace-team/resourcing/job-listings/interested-workers" element={<Interests />} />
            <Route path="/pace-team/resourcing/workers-availability" element={<WorkersAvailability />} />
            <Route path="/pace-team/resourcing/web-forms" element={<WebForms />} />
            <Route path="/pace-team/resourcing/resource-tracker/fatigue-check" element={<FatigueCheck />} />
            <Route path="/pace-team/resourcing/distance-matrices" element={<LocationMatrices />} />
            <Route path="/pace-team/resourcing/resource-tracker" element={<Home />} />
            <Route path="/pace-team/fatigue-calculations" element={<FatigueCalculation />} />
            <Route path="/pace-team/fatigue-calculations/fatigue-user" element={<FatigueUser />} />
            <Route path="/pace-team/upload-weekly-sheet" element={<MacrailUploadPage />} />
            <Route path="/pace-team/resourcing/generate-fatigues" element={<GenerateFatigues />} />
            <Route path="/pace-team/resourcing/generate-hours-report" element={<GenerateWeeklyHours />} />
            <Route path="/pace-team/resourcing/resource-tracker/weekly-new-users" element={<WeeklyNewUsersTable />} />
            <Route path="/pace-team/resourcing/identification-type" element={<IdentificationType />} />
            <Route path="/pace-team/calendar-downloads" element={<CalendarDownloads />} /> 
            <Route path="/pace-team/profile-update-requests" element={<PendingUpdates />} /> 
            <Route path="/pace-team/cancelled-shifts" element={<CancelledShifts />} />
            <Route path="/profile/update/:token" element={<UpdateDataPage />} />
            <Route path="/data-deletion/request/:token" element={<RequestDelete />} />
            <Route
              path="*"
              element={
                <Navigate
                  to="/pace-team/resourcing/resource-tracker"
                  replace
                />
              }
            />
          </Routes>
        </Layout>
      )}
      {!state.user?.token && (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/profile/update/:token" element={<UpdateDataPage />} />
          <Route path="/data-deletion/request/:token" element={<RequestDelete />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      )}
      <ToastContainer style={{ width: "350px" }} />
    </>
  );
};

export default App;
